/* TWS product page (tiered): Specification-first tabs (accordion on phones), Buy now direct checkout, Notify me, info tips. */
(function () {
  /* Tabs on tablet/desktop; an accordion on phones (below 750px), switching live with the viewport. */
  function initTabs(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    var accs = Array.prototype.slice.call(root.querySelectorAll('.tws-tabs__acc'));
    if (!tabs.length) return;
    var mq = window.matchMedia('(max-width: 749px)');
    function panelFor(el) { return document.getElementById(el.getAttribute('aria-controls')); }
    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var p = panelFor(t);
        if (p) p.hidden = !on;
      });
      if (focus) tab.focus();
      if (!mq.matches) tab.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
    function setMode() {
      var acc = mq.matches;
      root.classList.toggle('is-accordion', acc);
      accs.forEach(function (a, i) {
        var p = panelFor(a);
        if (!p) return;
        if (acc) {
          p.setAttribute('role', 'region');
          p.setAttribute('aria-label', a.textContent.trim());
          p.removeAttribute('aria-labelledby');
          p.removeAttribute('tabindex');
          a.setAttribute('aria-expanded', p.hidden ? 'false' : 'true');
        } else {
          p.setAttribute('role', 'tabpanel');
          p.removeAttribute('aria-label');
          p.setAttribute('aria-labelledby', tabs[i].id);
          p.tabIndex = 0;
        }
      });
      if (!acc) {
        var open = tabs.filter(function (t) { return !panelFor(t).hidden; })[0] || tabs[0];
        select(open, false);
      }
    }
    accs.forEach(function (a) {
      a.addEventListener('click', function () {
        var p = panelFor(a);
        var open = a.getAttribute('aria-expanded') !== 'true';
        a.setAttribute('aria-expanded', open ? 'true' : 'false');
        p.hidden = !open;
      });
    });
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(tab, false); });
      tab.addEventListener('keydown', function (e) {
        var rtl = getComputedStyle(root).direction === 'rtl';
        var next = rtl ? 'ArrowLeft' : 'ArrowRight';
        var prev = rtl ? 'ArrowRight' : 'ArrowLeft';
        var to = null;
        if (e.key === next) to = tabs[(i + 1) % tabs.length];
        else if (e.key === prev) to = tabs[(i - 1 + tabs.length) % tabs.length];
        else if (e.key === 'Home') to = tabs[0];
        else if (e.key === 'End') to = tabs[tabs.length - 1];
        if (to) { e.preventDefault(); select(to, true); }
      });
    });
    setMode();
    if (mq.addEventListener) mq.addEventListener('change', setMode);
  }

  /* Notify me (sold out): the button opens the email form under the row; the sticky bar's button scrolls to it. */
  function initNotify() {
    var box = document.querySelector('.tws-notify');
    if (!box) return;
    var toggle = document.querySelector('.tws-notify__toggle');
    var posted = !!box.querySelector('.tws-notify__done, .tws-notify__error');
    function open(scroll) {
      box.classList.add('is-open');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      if (scroll) box.scrollIntoView({ block: 'center', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      var input = box.querySelector('input[type="email"]');
      if (input) setTimeout(function () { input.focus({ preventScroll: true }); }, scroll ? 350 : 0);
    }
    if (posted || /customer_posted=true/.test(location.search)) open(false);
    document.querySelectorAll('[data-tws-notify-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn === toggle && box.classList.contains('is-open')) {
          box.classList.remove('is-open');
          toggle.setAttribute('aria-expanded', 'false');
          return;
        }
        open(btn !== toggle);
      });
    });
  }

  /* Buy now: add this watch over the Cart AJAX API, then go straight to checkout. If the watch is already
     in the cart (one-of-one stock), the add fails but checkout still has it, so continue anyway.
     Without JS the form posts to /cart/add with return_to=/checkout. */
  function initBuyNow(form) {
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
      btn.setAttribute('aria-busy', 'true');
      var id = form.querySelector('[name="id"]').value;
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var inCart = (cart.items || []).some(function (it) { return String(it.variant_id) === String(id); });
          if (inCart) return true;
          return fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
          }).then(function (r) {
            if (r.ok) return true;
            return r.json().then(function (j) { throw new Error(j.description || j.message || 'This watch could not be added.'); });
          });
        })
        .then(function () { window.location.href = '/checkout'; })
        .catch(function (err) {
          btn.removeAttribute('aria-busy');
          var wrap = form.closest('[data-tws-ctas]');
          var box = wrap && wrap.querySelector('.product-form__error-message-wrapper');
          if (box) {
            box.hidden = false;
            box.querySelector('.product-form__error-message').textContent = err.message;
          }
        });
    });
  }

  /* Info tips: tap toggles (iOS doesn't focus buttons on tap); Escape or a tap elsewhere closes. */
  function initInfoTips() {
    var tips = Array.prototype.slice.call(document.querySelectorAll('.tws-info'));
    if (!tips.length) return;
    function closeAll(except) { tips.forEach(function (t) { if (t !== except) t.classList.remove('is-open'); }); }
    tips.forEach(function (tip) {
      var btn = tip.querySelector('.tws-info__btn');
      btn.setAttribute('aria-expanded', 'false');
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = !tip.classList.contains('is-open');
        closeAll(tip);
        tip.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
    document.addEventListener('click', function () { closeAll(null); });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      closeAll(null);
      tips.forEach(function (t) { t.classList.add('is-dismissed'); var b = t.querySelector('.tws-info__btn'); b.setAttribute('aria-expanded', 'false'); });
    });
    tips.forEach(function (t) { t.addEventListener('mouseleave', function () { t.classList.remove('is-dismissed'); }); t.addEventListener('focusout', function () { t.classList.remove('is-dismissed', 'is-open'); }); });
  }

  /* Add-to-cart errors ("+"): shown as a full-width notice under the buy row, in plain words. */
  function initCartNotice() {
    document.querySelectorAll('.tws-buyrow').forEach(function (row) {
      var box = row.querySelector('.product-form__error-message-wrapper');
      var msg = box && box.querySelector('.product-form__error-message');
      if (!box || !msg) return;
      var note = document.createElement('p');
      note.className = 'tws-buyrow-notice';
      note.setAttribute('role', 'status');
      note.hidden = true;
      row.insertAdjacentElement('afterend', note);
      var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
      function sync() {
        var text = (msg.textContent || '').trim();
        if (box.hidden || !text) { note.hidden = true; return; }
        if (/maximum|already|not enough|sold out|can.?t add/i.test(text)) {
          note.innerHTML = '<span>This watch is already in your cart.</span> <a href="' + cartUrl + '">View cart</a>';
        } else {
          note.textContent = text;
        }
        note.hidden = false;
      }
      new MutationObserver(sync).observe(box, { attributes: true, attributeFilter: ['hidden'], childList: true, subtree: true, characterData: true });
      sync();
    });
  }

  // Pop-ups: the gallery magnifier and links to store pages (/pages/…, /policies/…) open in a closable dialog,
  // so the shopper never leaves the product page. Cmd/Ctrl-click still opens a new tab.
  function initModal() {
    var root = document.querySelector('.tws-pdp');
    if (!root || !window.HTMLDialogElement) return;
    var dlg = document.createElement('dialog');
    dlg.className = 'tws-modal';
    dlg.setAttribute('aria-labelledby', 'tws-modal-title');
    dlg.innerHTML =
      '<div class="tws-modal__head"><p class="tws-modal__title" id="tws-modal-title"></p>' +
      '<button type="button" class="tws-modal__close" aria-label="Close"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button></div>' +
      '<div class="tws-modal__body"></div>';
    document.body.appendChild(dlg);
    var title = dlg.querySelector('.tws-modal__title'), body = dlg.querySelector('.tws-modal__body');
    var images = [], at = 0;

    function open(kind, label) {
      dlg.className = 'tws-modal tws-modal--' + kind;
      title.textContent = label;
      if (!dlg.open) dlg.showModal();
      document.documentElement.classList.add('tws-modal-open');
    }
    function close() { if (dlg.open) dlg.close(); }
    dlg.addEventListener('close', function () { body.innerHTML = ''; document.documentElement.classList.remove('tws-modal-open'); });
    dlg.querySelector('.tws-modal__close').addEventListener('click', close);
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });

    function showImage(i) {
      at = (i + images.length) % images.length;
      var many = images.length > 1;
      body.innerHTML =
        '<figure class="tws-modal__figure"><img src="' + images[at] + '" alt=""></figure>' +
        (many ? '<button type="button" class="tws-modal__nav" data-dir="-1" aria-label="Previous image"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="m14.5 6-6 6 6 6"/></svg></button>' +
          '<button type="button" class="tws-modal__nav" data-dir="1" aria-label="Next image"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="m9.5 6 6 6-6 6"/></svg></button>' : '');
      title.textContent = 'Image ' + (at + 1) + ' of ' + images.length;
      body.querySelectorAll('.tws-modal__nav').forEach(function (b) {
        b.addEventListener('click', function () {
          var dir = +b.getAttribute('data-dir') * (getComputedStyle(dlg).direction === 'rtl' ? -1 : 1);
          showImage(at + dir);
        });
      });
    }
    dlg.addEventListener('keydown', function (e) {
      if (!dlg.classList.contains('tws-modal--image') || images.length < 2) return;
      var rtl = getComputedStyle(dlg).direction === 'rtl';
      if (e.key === 'ArrowRight') showImage(at + (rtl ? -1 : 1));
      if (e.key === 'ArrowLeft') showImage(at + (rtl ? 1 : -1));
    });

    // Shopify refuses to show storefront pages in a frame (X-Frame-Options: DENY), so the page's main content is
    // fetched and placed in the dialog. Its inline scripts are re-run, any stylesheet or script it needs that this
    // page lacks is added, and app forms (Globo form builder on Sell a Watch) are started again.
    var loaded = {};
    function addAsset(tag, url) {
      if (!url || loaded[url] || document.querySelector(tag + '[' + (tag === 'link' ? 'href' : 'src') + '="' + url + '"]')) return;
      loaded[url] = true;
      var el = document.createElement(tag);
      if (tag === 'link') { el.rel = 'stylesheet'; el.href = url; document.head.appendChild(el); }
      else { el.src = url; el.defer = true; document.head.appendChild(el); }
    }
    function showPage(url, label) {
      open('page', label);
      body.innerHTML = '<p class="tws-modal__loading">Loading…</p>';
      fetch(url, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          if (!dlg.open) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var main = doc.querySelector('.shopify-policy__container') || doc.querySelector('#MainContent') || doc.querySelector('main');
          if (!main) throw new Error('no content');
          doc.querySelectorAll('link[rel="stylesheet"][href]').forEach(function (l) { addAsset('link', l.getAttribute('href')); });
          var box = document.createElement('div');
          box.className = 'tws-modal__content';
          box.innerHTML = main.innerHTML;
          box.querySelectorAll('nav[aria-label*="readcrumb" i], .breadcrumbs, .twc-ph__crumbs').forEach(function (n) { n.remove(); });
          body.innerHTML = '';
          body.appendChild(box);
          box.querySelectorAll('script').forEach(function (old) {
            if (old.src) { addAsset('script', old.getAttribute('src')); old.remove(); return; }
            var s = document.createElement('script');
            for (var k = 0; k < old.attributes.length; k++) s.setAttribute(old.attributes[k].name, old.attributes[k].value);
            s.textContent = old.textContent;
            old.replaceWith(s);
          });
          if (box.querySelector('.globo-formbuilder') && window.Globo && Globo.FormBuilder && Globo.FormBuilder.initialize) {
            try { Globo.FormBuilder.initialize(); } catch (err) { /* the form app failed: the rest of the page still shows */ }
          }
          box.scrollTop = 0;
        })
        .catch(function () {
          body.innerHTML = '<p class="tws-modal__loading">This page could not be loaded. <a href="' + url + '" data-tws-no-modal>Open it instead</a>.</p>';
        });
    }

    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a || !root.contains(a) || a.hasAttribute('data-tws-no-modal')) return;
      if (a.classList.contains('tws-pdp__zoom')) {
        e.preventDefault();
        var seen = {};
        images = [];
        root.querySelectorAll('a.tws-pdp__zoom').forEach(function (z) {
          var n = parseInt((z.getAttribute('aria-label') || '').replace(/\D+/g, ' ').trim().split(' ')[0], 10) || images.length + 1;
          if (!seen[z.href]) { seen[z.href] = n; images[n - 1] = z.href; }
        });
        images = images.filter(Boolean);
        open('image', '');
        showImage(Math.max(0, images.indexOf(a.href)));
        return;
      }
      var url;
      try { url = new URL(a.getAttribute('href'), location.href); } catch (err) { return; }
      if (url.origin !== location.origin || !/^\/(pages|policies)\//.test(url.pathname)) return;
      e.preventDefault();
      var label = (a.getAttribute('data-modal-title') || a.textContent || '').replace(/\s+/g, ' ').replace(/[→›]/g, '').trim();
      var head = a.querySelector('strong, .tws-pdp__assure-title');
      if (head) label = head.textContent.trim();
      showPage(url.href, label || 'The Watch Scanner');
    });
  }

  function init() {
    initModal();
    initCartNotice();
    initInfoTips();
    initNotify();
    document.querySelectorAll('[data-tws-tabs]').forEach(initTabs);
    document.querySelectorAll('form[data-tws-buy-now]').forEach(initBuyNow);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
